<template>
  <v-container>
    <v-card
      color="#efefef"
      class="ma-0 mb-5 "
    >
      <v-row
        justify="center"
        class="pa-4"
      >
        <v-col
          cols="12"
        >
          <v-btn
            x-small
            @click="$emit('viewCarnet')"
          >
            controlla carnet
          </v-btn>
          <span v-if="Object.entries(carnet??[]).length>0">Utilizzo <b>CARNET {{ carnet.CNEF_NUMERO }} </b> buono nr. <b>{{ carnet.NEXT_ORBF_BUONO }}</b></span>
        </v-col>
        <v-col
          cols="12"
        >
          <v-form
            ref="form"
            v-model="validForm"
          >
            <v-text-field
              ref="desrif"
              v-model="steporder.desrif"
              class="uppercase-text"
              autofocus
              outlined
              label="Riferimento"
              hint="Quanto indicato come 'riferimento' sarà utilizzato come identificativo dell'ordine abbinato al numero risultante al termine del processo in corso"
              placeholder=""
              required
              :rules="[rules.required,rules.min]"
              @blur="$set(steporder,'desrif',steporder.desrif?.toUpperCase())"
            />
          </v-form>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-card
            class="text-center"
            :color="steporder.monsmo === 'M' && steporder.clipon === '' ? 'yellow' : 'white'"
            @click="$set(steporder,'monsmo','M');$set(steporder,'clipon','');"
          >
            <v-img
              class="mx-auto"
              :src="`./img/linee/${linea.codlin}_${linea.label}.png`"
              width="250"
              contain
            />

            Montato
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-card
            class="text-center"
            :color="steporder.monsmo === 'S' ? 'yellow' : 'white'"
            :outlined="Object.entries($store.state.carnet??[]).length>0 "
            :disabled="Object.entries($store.state.carnet??[]).length>0"
            @click="$set(steporder,'monsmo','S');$set(steporder,'clipon','');"
          >
            <v-img
              class="mx-auto"
              :src="`./img/linee/${linea.codlin}_${linea.label}_S.png`"
              width="250"
              contain
            />

            Smontato <i
              v-if="Object.entries($store.state.carnet??[]).length>0"
              class="ml-1"
            >Non ammesso con Carnet</i>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-btn
      color="primary"
      :disabled="!validForm || !steporder.monsmo"
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="$emit('prevStep', 0)"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Step1',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        steporder: {},
        validForm: true,
      }
    },

    computed: {
      ...mapState(['auth', 'order', 'carnet', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      rules () {
        return {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
        }
      },
      linea () {
        if (!this.order.codlin) {
          return { codlin: 0, label: '' }
        }
        return this.clidata.anlin.filter(item => item.codlin === this.order.codlin)[0]
      },
    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    mounted () {
      this.initData(this.step)
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          console.log('load', this.$options.name)
          this.steporder = Object.assign({}, this.order)
          if (!this.steporder.step) {
            this.steporder.step = this.step
          }
        }
      },
      nextStep () {
        if (!this.validForm && this.steporder.monsmo) {
          return
        }
        var monsmo = '' // this.steporder.monsmo

        if (monsmo === 'M') {
          // if (this.step > this.steporder.step) { this.steporder.step = this.step }
          console.log('steporder', this.steporder, this.step)
          this.$store.commit('setOrder', this.steporder)
          this.$emit('nextStep', this.step + 1)
        } else if (monsmo === 'S') {
          this.$set(this.steporder, 'lens', null)
          if (this.step > this.steporder.step) { this.steporder.step = this.step + 2 }
          this.$store.commit('setOrder', this.steporder)
          this.$emit('nextStep', this.step + 2)
        } else {
          console.log('steporder', this.steporder, this.step)
          this.$store.commit('setOrder', this.steporder)
          this.$emit('nextStep', this.step + 1)
        }
      },
    },
  }
</script>
